import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { selectUser } from "redux/slices/userSlice";

export const RootRedirect = () => {
  const { homeRoute } = useSelector(selectUser);
  return <Redirect to={homeRoute || "/profile"} />;
};
